import React, { useRef } from 'react';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import IconButton from '@mui/material/IconButton';
import AccountCircle from '@mui/icons-material/AccountCircle';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import Input from '@mui/material/Input';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { Button, Grid, Typography, Box, FormHelperText, Alert } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { loginActions } from '../../actions/loginAction';
import { LoginLoader } from '../utils/LoginLoader';
import { LoadingButton } from '@mui/lab';

function Signin({ setForgotPasswordEnable }) {
  const formRef = useRef();
  const [showPassword, setShowPassword] = React.useState(false);
  const dispatch = useDispatch();
  const loginLoader = useSelector((state) => state.loggedIn.loginLoader);

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <Formik
      initialValues={{
        Username: '',
        password: '',
      }}
      onSubmit={(values) => {
        localStorage.setItem('pyuseridentifier', values.Username);
        localStorage.setItem('password', values.password);
        localStorage.setItem('isSSO', 'false');
        dispatch(loginActions.loginLoader({}));
        dispatch(loginActions.IsUserLoggedIn(true, values.Username));
      }}
      innerRef={formRef}
      validationSchema={Yup.object().shape({
        Username: Yup.string().required(`Please enter Username`),
        password: Yup.string().required(`Please enter Password`),
      })}
      validateOnChange={true}
      validateOnBlur={false}>
      {({ values, handleChange, touched, errors }) => (
        <Form noValidate autoComplete="off">
          <Box
            sx={{
              padding: '20px',
              // borderRadius: '12px',
              // boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
              backgroundColor: '#ffffff',
            }}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <FormControl
                  fullWidth
                  error={errors.Username && touched.Username}
                  variant="standard"
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: '8px',
                      backgroundColor: '#f9f9f9',
                    },
                  }}>
                  <InputLabel htmlFor="input-with-icon-adornment">
                    Username or Email
                  </InputLabel>
                  <Input
                    name="Username"
                    onChange={handleChange}
                    id="input-with-icon-adornment"
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton disabled>
                          <AccountCircle color="primary" />
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                  <FormHelperText>
                    {errors.Username && touched.Username ? errors.Username : ''}
                  </FormHelperText>
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <FormControl
                  fullWidth
                  error={errors.password && touched.password}
                  variant="standard"
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: '8px',
                      backgroundColor: '#f9f9f9',
                    },
                  }}>
                  <InputLabel htmlFor="password">Password</InputLabel>
                  <Input
                    id="password"
                    name="password"
                    type={showPassword ? 'text' : 'password'}
                    onChange={handleChange}
                    value={values.password}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}>
                          {showPassword ? (
                            <Visibility color="primary" />
                          ) : (
                            <VisibilityOff color="primary" />
                          )}
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                  <FormHelperText>
                    {errors.password && touched.password ? errors.password : ''}
                  </FormHelperText>
                </FormControl>
              </Grid>

              <Grid item xs={12} sx={{ textAlign: 'right' }}>
                <Button
                  onClick={() => setForgotPasswordEnable(true)}
                  sx={{
                    textTransform: 'none',
                    fontSize: '12px',
                    color: '#3866fa',
                    '&:hover': {
                      textDecoration: 'underline',
                    },
                  }}>
                  Forgot password?
                </Button>
              </Grid>

              <Grid item xs={12} sx={{ textAlign: 'center' }}>
                <LoadingButton
                  color="primary"
                  variant="contained"
                  disabled={loginLoader}
                  loading={loginLoader}
                  type="submit"
                  sx={{
                    borderRadius: '8px',
                    padding: '10px 20px',
                    fontWeight: 'bold',
                    textTransform: 'none',
                  }}>
                  Login
                  {/* {loginLoader && (
                    <Box sx={{ marginLeft: '50px' }}>
                      <LoginLoader />
                    </Box>
                  )} */}
                </LoadingButton>
              </Grid>
            </Grid>
          </Box>
        </Form>
      )}
    </Formik>
  );
}

export default Signin;
